const btnConfirmDialog = {
  cancel: 'CANCELAR',
  ok: 'OK'
};

export default btnConfirmDialog;
